import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface SubmitButtonProps {
  isLoading: boolean;
  mode: "login" | "register";
}

export function SubmitButton({ isLoading, mode }: SubmitButtonProps) {
  return (
    <Button type="submit" className="w-full" disabled={isLoading}>
      {isLoading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
      {mode === "login" ? "Sign In" : "Register"}
    </Button>
  );
}